import "./style.scss";

import React, { useRef } from "react";
import { AreaList, IAreaListRef } from "../area-list/area-list";
import { PickAndPackHeader } from "./pick-and-pack-header";
import { context } from "../../../../context/context";
import { Permission } from "../../../../context/permission";
import { useParams } from "react-router-dom";

export const PickAndPackComponent = () => {
    const params = useParams();
    const areaListRef = useRef<IAreaListRef>();

    if (params.operationCode === undefined || params.batchId === undefined) {
        return <div/>;
    }

    if (context.hasPermission(Permission.FeatureBlueBrand)) {
        return <div/>;
    }

    return <div>
        <PickAndPackHeader operationCode={params.operationCode} batchId={Number(params.batchId)}
                           reloadAreaList={async () => await areaListRef.current?.reloadList() }/>
        <AreaList ref={areaListRef}
                  operationCode={params.operationCode}
                  batchId={Number(params.batchId)}
        />
    </div>;
};
